/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepAuthentication
 */
export interface StepAuthentication extends SignupStep {
    /**
     * The redirect path, found in the signup workflow if present
     * @type {string}
     * @memberof StepAuthentication
     */
    redirectPath?: string;
    /**
     * an email, if already given to prefilled
     * @type {string}
     * @memberof StepAuthentication
     */
    prefilledEmail?: string;
}

/**
 * Check if a given object implements the StepAuthentication interface.
 */
export function instanceOfStepAuthentication(value: object): value is StepAuthentication {
    return true;
}

export function StepAuthenticationFromJSON(json: any): StepAuthentication {
    return StepAuthenticationFromJSONTyped(json, false);
}

export function StepAuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepAuthentication {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'redirectPath': json['redirectPath'] == null ? undefined : json['redirectPath'],
        'prefilledEmail': json['prefilledEmail'] == null ? undefined : json['prefilledEmail'],
    };
}

export function StepAuthenticationToJSON(value?: StepAuthentication | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'redirectPath': value['redirectPath'],
        'prefilledEmail': value['prefilledEmail'],
    };
}

